export default "__VITE_ASSET__Bk768VPP__"